import React from 'react';
import { MARKS } from '../../constants';

const renderMark = (props, editor, next) => {
  const { mark, attributes, children } = props;
  const { data } = mark;
  switch (mark.type) {
    case MARKS.BOLD:
      return <strong {...attributes}>{children}</strong>;
    case MARKS.ITALIC:
      return <em {...attributes}>{children}</em>;
    case MARKS.UNDERLINE:
      return <u {...attributes}>{children}</u>;
    case MARKS.FONT_SIZE:
      return (
        <span {...attributes} style={{ fontSize: data.get('size') }}>
          {children}
        </span>
      );
    case MARKS.LINE_HEIGHT:
      return (
        <span {...attributes} style={{ lineHeight: data.get('lineHeight') }}>
          {children}
        </span>
      );
    case MARKS.FONT_COLOR:
      return (
        <span {...attributes} style={{ color: data.get('color') }}>
          {children}
        </span>
      );
    default:
      return next();
  }
};

export default  renderMark;
